import { render, staticRenderFns } from "./SwitchCheckbox.vue?vue&type=template&id=b55d6632"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SwitchCheckbox.vue?vue&type=style&index=0&id=b55d6632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports